import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "aliasInput", "aliasFeedback", "emailDisplay"]

  connect() {
    // Optional: preload message
    console.log("👤 user_search_controller connected")
  }

  // === Autocomplete Lookup ===
  lookup() {
    const query = this.inputTarget.value.trim()
    if (query.length < 1) {
      this.resultsTarget.innerHTML = ""
      return
    }

    fetch(`/users/chat_user_search?q=${encodeURIComponent(query)}`)
      .then(response => response.json())
      .then(users => {
        this.resultsTarget.innerHTML = users.map(user => `
          <div 
            data-action="click->user-search#select"
            data-id="${user.id}"
            class="cursor-pointer hover:bg-gray-700 px-2 py-1 rounded">
            ${user.alias ? user.alias.toUpperCase() : `User #${user.id}`}
          </div>
        `).join("")
      })
  }

  select(event) {
    const id = event.currentTarget.dataset.id
    this.inputTarget.value = id
    this.resultsTarget.innerHTML = ""
    this.inputTarget.form.submit()
  }

  // === Alias Validator & Email Updater ===
  validateAlias(event) {
    const alias = this.aliasInputTarget.value
    const regex = /^[a-zA-Z0-9]*$/

    // Update dynamic email display
    this.emailDisplayTarget.textContent = alias ? `${alias}@313.cash` : ""

    if (!regex.test(alias)) {
      this.aliasFeedbackTarget.textContent = "Only letters and numbers allowed."
      this.aliasInputTarget.value = alias.replace(/[^a-zA-Z0-9]/g, '')
      return
    } else {
      this.aliasFeedbackTarget.textContent = ""
    }

    if (alias.length > 0) {
      this.checkAliasUniqueness(alias)
    } else {
      this.aliasFeedbackTarget.textContent = ""
    }
  }

  checkAliasUniqueness(alias) {
    fetch(`/check_alias_uniqueness?alias=${encodeURIComponent(alias)}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
      .then(response => response.json())
      .then(data => {
        if (data.is_unique) {
          this.aliasFeedbackTarget.style.color = "green"
          this.aliasFeedbackTarget.textContent = "Alias is available!"
        } else {
          this.aliasFeedbackTarget.style.color = "red"
          this.aliasFeedbackTarget.textContent = "Alias is already taken."
        }
      })
      .catch(error => {
        console.error("Alias check failed:", error)
      })
  }
}


